import { useEffect } from 'react'
import { updateFaviconBadge, resetFaviconBadge } from '@/lib/utils/favicon'
import { useUnreadCount } from './useUnreadCount'

export const useFaviconBadge = (): void => {
  const { data } = useUnreadCount()
  const count = data?.count ?? 0

  useEffect(() => {
    void updateFaviconBadge(count)
  }, [count])

  useEffect(() => {
    return () => {
      resetFaviconBadge()
    }
  }, [])
}
